import type { UsageMetricKey } from './usageMetricKey';

export enum UsageStatus {
    Neutral = 'neutral',
    Ok = 'ok',
    Warning = 'warning',
    Over = 'over',
}

export interface CustomerUsagePeriod {
    tierPricingGroupDisplayName: string | null;
    year: number | null;
    month: number | null;
    currentUsage: number | null;
    includedQuantity: number | null;
    unitPrice: number | null;
    isCurrent: boolean;
}

export interface CustomerUsageMetric {
    metricKey: UsageMetricKey;
    productId: string;
    articleNumber: string | null;
    productName: string | null;
    periods: CustomerUsagePeriod[];
}

export interface CustomerUsageOverview {
    customerId: string;
    isApplicable: boolean;
    metrics: CustomerUsageMetric[];
}
